export default __webpack_public_path__ + "static/media/options_icon.1680eda4.svg";